let lastViewportWidth = window.visualViewport.width;
const breakpoint = 768;

window.addEventListener('resize', () => {
    const currentViewportWidth = window.visualViewport.width;

    // Check if the breakpoint is crossed
    if (
        (lastViewportWidth >= breakpoint && currentViewportWidth < breakpoint) ||
        (lastViewportWidth < breakpoint && currentViewportWidth >= breakpoint)
    ) {
        window.location.reload();
    }

    lastViewportWidth = currentViewportWidth;
});